import React from 'react';
import { useQuery, gql } from '@apollo/client';
import Chapter from './Chapter';
import MultiColumnsSelection from '../components/multiColumnsDropDown/MultiColumnsSelection';
import { Grid, Fab, Box } from '@material-ui/core';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  fabRight: {
    position: 'fixed',
    bottom: theme.spacing(12),
    // top: 50%,
    right: theme.spacing(1.2)
  },
  fabLeft: {
    position: 'fixed',
    bottom: theme.spacing(12),
    // top: 50%,
    left: theme.spacing(1)
  }
}));

function KinhThanh() {
  const classes = useStyles();
  // const theme = useTheme();
  const [bible, setBible] = React.useState({
    version: 'V02',
    book: 'V02B43',
    chapter: 'V02B43C001',
    bookSelectedIndex: 42,
    chapterSelectedIndex: 0,
    versionSelectedIndex: 1
  });
  const versionQuery = gql`
    {
      versions {
        id
        name
        shortName
      }
    }
  `;

  const booksQuery = gql`
    query($id: String!) {
      bible(id: $id) {
        id
        name
      }
    }
  `;

  const chaptersQuery = gql`
    query($id: String!) {
      book(id: $id) {
        chaptersId {
          id
          chapterNumber
        }
      }
    }
  `;
  const chapterQuery = gql`
    query($id: String!) {
      chapter(id: $id) {
        title
        chapterNum
        nextChapterId
        previousChapterId
        audioUrl
        textDirection
        wordForChapter
        paragraph {
          id
          subtitle
          verse {
            id
            verseNum
            text
            startVerse
          }
        }
      }
    }
  `;

  const { data: versions } = useQuery(versionQuery);

  const { data: booksData } = useQuery(booksQuery, {
    variables: { id: bible.version }
  });

  const { data: { book: { chaptersId } = {} } = {} } = useQuery(chaptersQuery, {
    variables: { id: bible.book }
  });
  const { error: chapterError, data: chapterData } = useQuery(chapterQuery, {
    variables: { id: bible.chapter }
  });
  if (chapterError) {
    console.log('error fetching', chapterError);
  }
  const chaptersIdData =
    chaptersId &&
    chaptersId.map(chapterId => {
      return { ...chapterId, name: chapterId.chapterNumber };
    });
  const versionChange = index => {
    const selectedVersion = versions.versions[index].id;
    // console.log('selected version: ', selectedVersion);
    const bookForVersion = bible.book.replace(bible.version, selectedVersion);
    // console.log('selected book: ', bookForVersion);
    const chapterForVersion = bible.chapter.replace(bible.version, selectedVersion);
    // console.log('version selected ', index, selectedVersion, bookForVersion, chapterForVersion);
    setBible({
      ...bible,
      version: selectedVersion,
      book: bookForVersion,
      chapter: chapterForVersion,
      versionSelectedIndex: index
    });
  };
  const bookChange = index => {
    const selectedBook = booksData && booksData.bible[index];
    setBible({
      ...bible,
      book: selectedBook && selectedBook.id,
      chapter: selectedBook && selectedBook.id.concat('C001'),
      bookSelectedIndex: index,
      chapterSelectedIndex: 0
    });
  };
  const chapterChange = index => {
    const chapterSelected = chaptersId && chaptersId[index];
    console.log('selected chapter', chapterSelected.id);
    setBible({ ...bible, chapter: chapterSelected.id, chapterSelectedIndex: index });
  };

  const handleBackForwardNav = (event, navigationId) => {
    const versionId = navigationId && navigationId.substring(0, 3);
    const bookId = navigationId && navigationId.substring(0, 6);
    const bookIndex = navigationId && parseInt(navigationId.substring(4, 6));
    const chapterIndex = navigationId && parseInt(navigationId.substring(7, 10));
    console.log('clicked back ', versionId, bookId, bookIndex, chapterIndex);
    setBible({
      ...bible,
      book: bookId,
      chapter: navigationId,
      bookSelectedIndex: bookIndex - 1,
      chapterSelectedIndex: chapterIndex - 1
    });
  };

  return (
    <div style={{ padding: 10 }}>
      {/* <Versions onVersionSelected={versionChange} /> */}
      {/* <Grid container direction="row" justify="space-evenly" alignItems="flex-start"> */}
      <Box display="flex" justifyContent="center" alignItems="center">
        <Grid container item xs={12}>
          <Grid container>
            <Grid item xs={3}>
              <MultiColumnsSelection
                id="versionsList"
                cols={1}
                data={versions && versions.versions}
                onSelect={versionChange}
                defaultValue={bible.versionSelectedIndex}
              />
            </Grid>
            {/* </Grid> */}
            {/* <Grid container direction="row" justify="center" alignItems="center"> */}
            <Grid item xs={3}>
              <MultiColumnsSelection
                id="booksList"
                cols={2}
                data={booksData && booksData.bible}
                onSelect={bookChange}
                defaultValue={bible.bookSelectedIndex}
              />
            </Grid>
            <Grid item xs={3}>
              <MultiColumnsSelection
                id="chaptersList"
                cols={chaptersId && chaptersId.length < 5 ? chaptersId.length : 5}
                data={chaptersIdData}
                onSelect={chapterChange}
                defaultValue={bible.chapterSelectedIndex}
              />
            </Grid>
            <Grid item xs={3}>
              <div align="right">
                {chapterData &&
                  chapterData.chapter.audioUrl &&
                  chapterData.chapter.selectedVersionaudioUrl !== null && (
                    <audio
                      src={chapterData.chapter && chapterData.chapter.audioUrl}
                      controls
                      type="audio/mpeg"
                    />
                  )}
              </div>
            </Grid>
          </Grid>
          <Grid container item xs={12}>
            {chapterData &&
              chapterData.chapter &&
              chapterData.chapter.nextChapterId !== 'null' && (
                <Fab
                  key="nextChapter"
                  color="primary"
                  aria-label="next"
                  className={classes.fabRight}
                  onClick={event => handleBackForwardNav(event, chapterData.chapter.nextChapterId)}
                >
                  <ArrowForwardIosIcon />
                </Fab>
              )}
            {chapterData &&
              chapterData.chapter &&
              chapterData.chapter.previousChapterId !== 'null' && (
                <Fab
                  color="primary"
                  key="prevChapter"
                  aria-label="prev"
                  className={classes.fabLeft}
                  onClick={event =>
                    handleBackForwardNav(event, chapterData.chapter.previousChapterId)
                  }
                >
                  <ArrowBackIosIcon />
                </Fab>
              )}
            <div style={{ padding: 60, width: '100%' }}>
              <Chapter chapterData={chapterData && chapterData.chapter} />
            </div>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
export default KinhThanh;
